import React, {Fragment, useEffect, useState} from "react";
import Helpers, {formatHoursWithDays} from "../../helpers";
import {Button, Chip, CircularProgress, Grid, IconButton, Paper, Typography} from "@mui/material";
import {ArrowBack, Settings, Add} from "@mui/icons-material";
import {FormHelperEnhancedSelectWrapper} from "../../components/EnhancedSelect";
import {Header, defaultResultsContainerStyles} from "../../theme";
import Moment from "moment";
import moment from "moment";
import {utilGetOrderStatusCounts, utilGetPartners, utilGetPartnerScorecards, utilGetSupplierGroups, utilUpdateSupplierGroup, utilDeleteSupplierGroup} from "../../utils/utils";
import {Field, Form} from "react-final-form";
import {calculator, IfEquals} from "../reports/scorecards";
import {FormHelperEnhancedTextWrapper} from "../../components/EnhancedTextField";
import "../reports/scorecards.css";
import ContentLoader from "../../components/content_loader";
import {ResponsiveBar} from "@nivo/bar";
import {PartnerPauseDialog} from "./components/PartnerPauseDialog";
import {PartnerUnpauseDialog} from "./components/PartnerUnpauseDialog";
import {AddToGroupDialog} from "./components/AddToGroupDialog";
import CatalogManagerResults from "../../components/CatalogManagerResults";
import EnhancedTable from "../../components/table";
import {fetchPartnerCompanyProfile, fetchPartnerConfiguration} from "../../utils/api";
import FileSaver from "filesaver.js-npm";
import Papa from 'papaparse';
import {defaultProfile} from "../settings/account_info";
import { CancellationReasons } from "../reports/scorecards";
import EnhancedErrorDialog from "../../components/EnhancedErrorDialog";
export const getEndDate = (endDate: any) => {
    if(endDate === Moment(new Date()).format('YYYY-MM-DD')){
        return Moment(new Date()).toISOString();
    }
    return Moment(endDate).toISOString();
}
const ClosuresTable = (props: any) => {
    const {closures} = props;
    const [config, setConfig] = useState<any>({
        getData: async function(){
            return closures;
        },
        savedSearchEnabled: true,
        columns: [
            { id: 'Day', filterable: true, sortable: true, searchable: true, label: 'Day Name' },
            {
                id: 'Start',
                label: 'Start Date',
                type: "date",
                hidden: false,
                toggleable: true,
                sortable: true,
                template: (row) => {
                    if (row.Start)
                        return moment(row.Start).format("MM/DD/YYYY");
                }
            },
            {
                id: 'End',
                label: 'End Date',
                type: "date",
                hidden: false,
                toggleable: true,
                sortable: true,
                template: (row) => {
                    if (row.End)
                        return moment(row.End).format("MM/DD/YYYY");
                }
            },
            {
                id: 'Warehouses',
                filterable: true,
                toggleable: true,
                sortable: true,
                searchable: true,
                label: 'Warehouse Codes',
                allowStringOperators: true,
                template: (row, column, colIndex, rowIndex) => (
                    <>
                        {row.Warehouses && row.Warehouses.join(", ")}
                    </>
                )
            }
        ],
        order: 'asc',
        orderBy: 'CompanyName',
        keyField: 'Id',
        pageSize: 20,
        filter: null,
        pageSizes: [10, 20, 50, 100],
        title: 'Partners'
    });
    const exportClosures = () => {
        let header = ["Day", "Start", "End", "Warehouse Codes"];
        let rows = [header].concat(closures.map(w => [
            w.Day,
            moment(w.Start).format("YYYY-MM-DD"),
            moment(w.End).format("YYYY-MM-DD"),
            w.Warehouses && w.Warehouses.join(", ")
        ]).map(row => row.map(cell => cell === null || cell === undefined ? "" : cell.toString())));
        let output = Papa.unparse(rows);
        let blob = new Blob([output], { type: "text/csv" });
        (FileSaver as any).saveAs(blob, 'closures.csv');
    }
    return (
        <EnhancedTable config={config} history={props.history} location={props.location}
                       key={"profile_warehouse_table"}
                       template={(table) =>
                           <CatalogManagerResults
                               isSelectable={false}
                               disableTermInUrl={true}
                               condensed={true}
                               noToolBar={true}
                               history={props.history} location={props.location}
                               table={table}
                               config={config} setConfig={setConfig}
                               resultsContainerStyles={defaultResultsContainerStyles}
                               renderButtonFiltersAfter={false}
                               tableHeader={
                                   <Grid container style={{justifyContent: "", padding: "1em"}}>
                                       <Typography variant={"h6"}>Closures</Typography>
                                   </Grid>
                               }
                               buttonFilters={
                                   <Grid container style={{gap: "0.5em", flex: 1}}>
                                       <Button variant={"outlined"}
                                        onClick={exportClosures}
                                       >
                                           Export CSV
                                       </Button>
                                   </Grid>
                               }
                           />
                       }
        />
    );
}
const HoursOfOperation = (props: any) => {
    const {hours} = props;
    let hoursObject = hours ?? [];
    const monday = hoursObject.find(r => r.Day === 'Monday');
    const tuesday = hoursObject.find(r => r.Day === 'Tuesday');
    const wednesday = hoursObject.find(r => r.Day === 'Wednesday');
    const thursday = hoursObject.find(r => r.Day === 'Thursday');
    const friday = hoursObject.find(r => r.Day === 'Friday');
    const saturday = hoursObject.find(r => r.Day === 'Saturday');
    const sunday = hoursObject.find(r => r.Day === 'Sunday');
    // Find first valid day with timezone
    let timezone = hoursObject.find(r => r.TimeZone);
    return (
        <Grid container>
            <Grid container>
                <Grid container direction={"column"} alignItems={"flex-start"}
                      style={{padding: "0.25em 0"}}>
                    <Typography color={"textSecondary"}>
                        Timezone
                    </Typography>
                    {!timezone ? "N/A" : (
                        <Typography>
                            {timezone.TimeZone ?? "N/A"}
                        </Typography>
                    )}
                </Grid>
            </Grid>
            <Grid container>
                <Grid container direction={"column"} alignItems={"flex-start"}
                      size={6} style={{padding: "0.25em 0"}}>
                    <Typography color={"textSecondary"}>
                        Monday
                    </Typography>
                    {!monday ? "N/A" : (
                        <>
                            <Typography>
                                {monday.Closed ? "Closed" : `${moment(monday.OpenTime, 'HH:mm:ss').format('hh:mm A')} - ${moment(monday.CloseTime, 'HH:mm:ss').format('hh:mm A')}`}
                            </Typography>
                        </>
                    )}
                </Grid>
                <Grid container direction={"column"} alignItems={"flex-start"}
                      size={6} style={{padding: "0.25em 0"}}>
                    <Typography color={"textSecondary"}>
                        Tuesday
                    </Typography>
                    {!tuesday ? "N/A" : (
                        <Typography>
                            {tuesday.Closed ? "Closed" : `${moment(tuesday.OpenTime, 'HH:mm:ss').format('hh:mm A')} - ${moment(tuesday.CloseTime, 'HH:mm:ss').format('hh:mm A')}`}
                        </Typography>
                    )}
                </Grid>
                <Grid container direction={"column"} alignItems={"flex-start"}
                      size={6} style={{padding: "0.25em 0"}}>
                    <Typography color={"textSecondary"}>
                        Wednesday
                    </Typography>
                    {!wednesday ? "N/A" : (
                        <Typography>
                            {wednesday.Closed ? "Closed" : `${moment(wednesday.OpenTime, 'HH:mm:ss').format('hh:mm A')} - ${moment(wednesday.CloseTime, 'HH:mm:ss').format('hh:mm A')}`}
                        </Typography>
                    )}
                </Grid>
                <Grid container direction={"column"} alignItems={"flex-start"}
                      size={6} style={{padding: "0.25em 0"}}>
                    <Typography color={"textSecondary"}>
                        Thursday
                    </Typography>
                    {!thursday ? "N/A" : (
                        <Typography>
                            {thursday.Closed ? "Closed" : `${moment(thursday.OpenTime, 'HH:mm:ss').format('hh:mm A')} - ${moment(thursday.CloseTime, 'HH:mm:ss').format('hh:mm A')}`}
                        </Typography>
                    )}
                </Grid>
                <Grid container direction={"column"} alignItems={"flex-start"}
                      size={6} style={{padding: "0.25em 0"}}>
                    <Typography color={"textSecondary"}>
                        Friday
                    </Typography>
                    {!friday ? "N/A" : (
                        <Typography>
                            {friday.Closed ? "Closed" : `${moment(friday.OpenTime, 'HH:mm:ss').format('hh:mm A')} - ${moment(friday.CloseTime, 'HH:mm:ss').format('hh:mm A')}`}
                        </Typography>
                    )}
                </Grid>
                <Grid container direction={"column"} alignItems={"flex-start"}
                      size={6} style={{padding: "0.25em 0"}}>
                    <Typography color={"textSecondary"}>
                        Saturday
                    </Typography>
                    {!saturday ? "N/A" : (
                        <Typography>
                            {saturday.Closed ? "Closed" : `${moment(saturday.OpenTime, 'HH:mm:ss').format('hh:mm A')} - ${moment(saturday.CloseTime, 'HH:mm:ss').format('hh:mm A')}`}
                        </Typography>
                    )}
                </Grid>
                <Grid container direction={"column"} alignItems={"flex-start"}
                      size={6} style={{padding: "0.25em 0"}}>
                    <Typography color={"textSecondary"}>
                        Sunday
                    </Typography>
                    {!sunday ? "N/A" : (
                        <Typography>
                            {sunday.Closed ? "Closed" : `${moment(sunday.OpenTime, 'HH:mm:ss').format('hh:mm A')} - ${moment(sunday.CloseTime, 'HH:mm:ss').format('hh:mm A')}`}
                        </Typography>
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
}
const WarehousesTable = (props: any) => {
    const {warehouses} = props;
    let warehousesObject = warehouses ?? [];
    const [config, setConfig] = useState<any>({
        getData: async function(){
            return warehousesObject.map(w => {
                const formattedAddress = `${w.Address1} ${w.Address2}${(w.Address1 || w.Address2) && ","} ${w.City} ${w.State}${(w.City || w.State) && ","} ${w.Zip}${w.Zip && ","} ${w.Country}`;
                return {
                    ...w,
                    Address: formattedAddress
                }
            })
        },
        savedSearchEnabled: true,
        columns: [
            { id: 'Name', filterable: true, sortable: true, searchable: true, label: 'Name' },
            { id: 'Code', filterable: true, sortable: true, searchable: true, label: 'Code', toggleable: true },
            { id: 'Type', filterable: true, sortable: true, searchable: true, label: 'Type', toggleable: true, allowStringOperators: true },
            { id: 'Address', filterable: true, sortable: true, searchable: true, label: 'Address', toggleable: true, allowStringOperators: true }
        ],
        order: 'asc',
        orderBy: 'CompanyName',
        keyField: 'Id',
        pageSize: 20,
        filter: null,
        pageSizes: [10, 20, 50, 100],
        title: 'Warehouses'
    });
    const exportWarehouses = () => {
        let header = ["Name", "Code", "Type", "Address"];
        let rows = [header].concat(warehousesObject.map(w => [
            w.Name,
            w.Code,
            w.Type,
            `${w.Address1} ${w.Address2}${(w.Address1 || w.Address2) && ","} ${w.City} ${w.State}${(w.City || w.State) && ","} ${w.Zip}${w.Zip && ","} ${w.Country}`
        ]).map(row => row.map(cell => cell === null || cell === undefined ? "" : cell.toString())));
        let output = Papa.unparse(rows);
        let blob = new Blob([output], { type: "text/csv" });
        (FileSaver as any).saveAs(blob, 'warehouses.csv');
    }
    return (
        <EnhancedTable config={config} history={props.history} location={props.location}
                       key={"profile_warehouse_table"}
                       template={(table) =>
                           <CatalogManagerResults
                               isSelectable={false}
                               disableTermInUrl={true}
                               condensed={true}
                               noToolBar={true}
                               history={props.history} location={props.location}
                               table={table}
                               config={config} setConfig={setConfig}
                               resultsContainerStyles={defaultResultsContainerStyles}
                               renderButtonFiltersAfter={false}
                               tableHeader={
                                   <Grid container style={{justifyContent: "", padding: "1em"}}>
                                       <Typography variant={"h6"}>Warehouses</Typography>
                                   </Grid>
                               }
                               buttonFilters={
                                   <Grid container style={{gap: "0.5em", flex: 1}}>
                                       <Button variant={"outlined"}
                                               onClick={exportWarehouses}
                                       >
                                           Export CSV
                                       </Button>
                                   </Grid>
                               }
                           />
                       }
        />
    );
}
const iconButtonSx = (theme: any) => ({
    backgroundColor: "white",
    border: "none",
    borderRadius: "6px",
    "& svg": { color: "rgba(0, 0, 0, 0.54)" }
});

interface PartnerManagerProps {
    location: { search: string; key?: string; [key: string]: any };
    history: { push: (path: string) => void; goBack: () => void; [key: string]: any };
    isRetailer?: boolean;
    setTitle?: (title: string, subtle?: boolean) => void;
    [key: string]: any;
}

export default function PartnerManager(props: PartnerManagerProps) {
    let urlPartnerId = new Helpers().queryString(props.location.search)["partnerId"];
    const [dataFilter, setDataFilter] = React.useState({
        start: Moment().add(-7, 'days').format('YYYY-MM-DD'),
        end: Moment().format('YYYY-MM-DD'),
        termType: '7days',
    });
    const [partnerVendorNumber, setPartnerVendorNumber] = React.useState<any>(null);
    const [partnerProfile, setPartnerProfile] = React.useState<any>({});
    const [partnerData, setPartnerData] = React.useState<any>({});
    const [scorecardData, setScorecardData] = React.useState<any>({});
    const [chartData, setChartData] = React.useState<any[]>([]);
    const [partnerGroups, setPartnerGroups] = React.useState<any[]>([]);
    const [availableGroups, setAvailableGroups] = useState<any[]>([]);
    const [addToGroupDialogOpen, setAddToGroupDialogOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [refreshing, setRefreshing] = useState(false);
    const [pauseDialogOpen, setPauseDialogOpen] = useState(false);
    const [unpauseDialogOpen, setUnpauseDialogOpen] = useState(false);
    const [error, setError] = useState({
        open: false,
        errorHeader: "",
        errorMessage: ""
    });
    const update = async (values: any) => {
        setDataFilter(values);
        setRefreshing(true);
        await getPartnerData(values);
        await loadChartData(values);
        setRefreshing(false);
    }
    const loadChartData = async (values?: any) => {
        const {start, end} = values ?? dataFilter;
        let startDateForChart = Moment(start).toISOString();
        let endDateForChart = getEndDate(end);
        let orderCountData = await utilGetOrderStatusCounts(props.isRetailer, urlPartnerId, startDateForChart, endDateForChart);
        // Success resolves to an array; failure to {open, errorHeader, errorMessage} (errorMessage may be
        // undefined). Bail on any non-array so the error object never reaches the .forEach/.map below.
        if (!Array.isArray(orderCountData)) return;
        orderCountData.forEach(r => r.Date = Moment(r.Date).format('MM/DD'));
        if(Moment(endDateForChart).format("HHmmss") === "000000"){ // don't include blank entry for last day in interval
            let exclude = Moment(endDateForChart).format('MM/DD');
            orderCountData = orderCountData.filter(r => r.Date !== exclude);
        }
        setChartData(orderCountData.map(r => {
            return {Date: r.Date, Cancelled: r.Cancelled, Shipped: r.Shipped, "Not Shipped": r.NotShipped}
        }));
        return true;
    }
    const getPartnerData = async (values?: any) => {
        const {start, end} = values ?? dataFilter;
        if (urlPartnerId) {
            // Get both partners & score data from selected timeframe and combine them //
            let partners = await utilGetPartners();
            // Array on success, {open, errorHeader, errorMessage} on failure (errorMessage may be undefined).
            // Discriminate on Array.isArray so a failure object never reaches the .find calls below.
            if (!Array.isArray(partners)) partners = [];
            let scoreCards = await utilGetPartnerScorecards(Moment(start).toISOString(), getEndDate(Moment(end).format('YYYY-MM-DD')), true);
            if (!Array.isArray(scoreCards)) scoreCards = [];
            // Find Specific Partner Data //
            // eslint-disable-next-line eqeqeq
            let partner = partners.find(partner => partner.Id == urlPartnerId);
            if (partner) {
                setPartnerData(partner);
            } else {
                setError({
                    open: true,
                    errorHeader: "Partner Not Found",
                    errorMessage: `Unable to find partner with ID ${urlPartnerId}. Please verify the partner ID and try again.`
                });
                setPartnerData({});
                return false;
            }
            // Find Specific Scorecard Data //
            // eslint-disable-next-line eqeqeq
            let scorecard = scoreCards.find(scorecard => scorecard.Id == urlPartnerId);
            if (scorecard) {
                // Ensure data exists for all scorecard properties if NoData is false //
                if (!scorecard.NoData) {
                    if (!scorecard.ShipmentTime) scorecard.ShipmentTime = {
                        TargetValue: 0,
                        ActualValue: 0,
                        Score: 0,
                        LetterGrade: 'N/A'
                    };
                    if (!scorecard.ShipPercent) scorecard.ShipPercent = {
                        TargetValue: 0,
                        ActualValue: 0,
                        Score: 0,
                        LetterGrade: 'N/A'
                    };
                    if (!scorecard.CancelPercent) scorecard.CancelPercent = {
                        TargetValue: 0,
                        ActualValue: 0,
                        Score: 0,
                        LetterGrade: 'N/A'
                    };
                }
                setScorecardData(scorecard);
            }
        }
        return true;
    }
    const getPartnerProfile = async () => {
        const resposne = await fetchPartnerCompanyProfile(urlPartnerId);
        if(!resposne.success) {
            return;
        }
        const profile = {...resposne.data};
        setPartnerProfile({...defaultProfile, ...profile});
        return true;
    }
    const getPartnershipConfigurations = async () => {
        const response = await fetchPartnerConfiguration(urlPartnerId);
        if(!response.success) {
            return;
        }
        const vendorNumberObject = response.data.find(p => p.PropertyName === "InventoryDefaultVendorNumber");
        const vendorNumber = vendorNumberObject ? vendorNumberObject.PropertyValue : null;
        setPartnerVendorNumber(vendorNumber);
        return true;
    }
    const handleRemoveFromGroup = async (groupId: string) => {
        try {
            setRefreshing(true);
            const group = partnerGroups.find(g => g.id === groupId);
            if (group) {
                const updatedPartnerIds = group.partners
                    .filter((p: any) => p.Id !== parseInt(urlPartnerId))
                    .map((p: any) => p.Id);
                // Delete if no partners left
                if (updatedPartnerIds.length === 0) {
                    const result = await utilDeleteSupplierGroup(groupId);
                    if (!result.errorMessage) {
                        await loadPartnerGroups();
                    } else {
                        setError({open: true, errorHeader: "Error", errorMessage: result.errorMessage});
                    }
                } 
                else { 
                    // Update the group with remaining partners
                    const result = await utilUpdateSupplierGroup(groupId, null, updatedPartnerIds);
                    if (!result.errorMessage) {
                        await loadPartnerGroups();
                    } else {
                        setError({open: true, errorHeader: "Error", errorMessage: result.errorMessage});
                    }
                }
            }
            setRefreshing(false);
        } catch (err: any) {
            setRefreshing(false);
            setError({open: true, errorHeader: "Error", errorMessage: err.message});
        }
    };
    const loadPartnerGroups = async () => {
        try {
            const groups = await utilGetSupplierGroups();
            // utilGetSupplierGroups resolves to an array on success or {errorMessage} on failure (no `open`,
            // and errorMessage may be undefined). Gate on Array.isArray so the error object never reaches the
            // .forEach below — keying off !errorMessage would let an undefined-message failure through.
            if (Array.isArray(groups) && urlPartnerId) {
                const partnerGroupData = [];
                const availableGroupData = [];
                groups.forEach(group => {
                    const groupObject = {
                        id: group.Name,  // Use Name as the identifier since API uses group names
                        name: group.Name,
                        partners: group.Partners || []
                    };
                    // Check if the current partner is in this group
                    if (group.Partners && group.Partners.some(p => p.Id === parseInt(urlPartnerId))) {
                        partnerGroupData.push(groupObject);
                    } else {
                        // This group is available for the partner to join
                        availableGroupData.push(groupObject);
                    }
                });
                // Sort both lists alphabetically
                partnerGroupData.sort((a, b) => 
                    a.name.toLowerCase().localeCompare(b.name.toLowerCase(), undefined, { numeric: true, sensitivity: 'base' })
                );
                availableGroupData.sort((a, b) => 
                    a.name.toLowerCase().localeCompare(b.name.toLowerCase(), undefined, { numeric: true, sensitivity: 'base' })
                );
                setPartnerGroups(partnerGroupData);
                setAvailableGroups(availableGroupData);
            }
        } catch (err) {
            console.error("Error loading partner groups:", err);
        }
        return true;
    }
    useEffect(() => {
        const init = async () => {
            setLoading(true);
            const partnerData = await getPartnerData();
            const chartData = await loadChartData();
            const profile = await getPartnerProfile();
            const configurations = await getPartnershipConfigurations();
            const groups = await loadPartnerGroups();
            if(partnerData && chartData && profile && configurations && groups) {
                setLoading(false);
            }   
        }
        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if(props.setTitle && partnerData.CompanyName) {
            props.setTitle(`PMC: ${partnerData.CompanyName}`, true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.setTitle, partnerData.CompanyName]);
    return (
        <div style={{padding: "24px 14px 24px 14px"}}>
            <Grid container justifyContent={"space-between"} direction={"row"} style={{gap: "2em"}}>
                <div style={{display: "flex", alignItems: "center", gap: "1em", width: "100%"}}>
                    <IconButton
                        sx={iconButtonSx}
                        style={{height: "36px", width: "36px"}}
                        onClick={(e) => {
                            e.preventDefault();
                            if (props.location.key === undefined)
                                props.history.push("/productonboardingcenter/catalog?catalog=retailer");
                            else
                                props.history.goBack();
                        }}
                        size="large">
                        <ArrowBack style={{height: "18px", width: "18px"}}/>
                    </IconButton>
                    <Header>
                        {loading ? "Loading..." : partnerData.CompanyName ?? "Unknown Partner"}
                    </Header>
                    <div style={{marginLeft: "auto", display: "flex", gap: "8px"}}>
                        <Button variant='outlined'
                                startIcon={<Settings style={{height: "18px", width: "18px"}}/>}
                                onClick={() => {
                                    if (partnerData.Status === "Live") setPauseDialogOpen(true);
                                    else setUnpauseDialogOpen(true);
                                }}
                        >
                            {partnerData.Status === "Live" ? "Pause" : "Unpause"}
                        </Button>
                        {/*<Button disabled={true} variant='contained'*/}
                        {/*        startIcon={<ExportIcon style={{height: "18px", width: "18px"}}/>}*/}
                        {/*>*/}
                        {/*    Save*/}
                        {/*</Button>*/}
                    </div>
                </div>
                {loading ? (
                    <Grid container>
                        <Grid size={9} container style={{padding: "1em 1em 1em 0", gap: "2em"}}>
                            <ContentLoader preserveAspectRatio='none' style={{height: '24em', width: '100%'}}
                                           primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>
                            <ContentLoader preserveAspectRatio='none' style={{height: '12em', width: '100%'}}
                                           primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>
                            <ContentLoader preserveAspectRatio='none' style={{height: '12em', width: '100%'}}
                                           primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>
                        </Grid>
                        <Grid size={3} style={{padding: "1em 0 1em 1em"}}>
                            <ContentLoader preserveAspectRatio='none' style={{height: '8em', width: '100%'}}
                                           primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>
                            <ContentLoader preserveAspectRatio='none' style={{height: '8em', width: '100%'}}
                                           primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>
                            <ContentLoader preserveAspectRatio='none' style={{height: '8em', width: '100%'}}
                                           primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>
                        </Grid>
                    </Grid>
                ) : (
                    <>
                        <Grid container spacing={2}>
                            <Grid size={9} container style={{gap: "1em"}}>
                                <Grid size={12} container>
                                    <Paper style={{width: "100%", padding: "1em"}}>
                                        <Grid container style={{marginBottom: "1.5em"}}>
                                            <Grid size={2} container justifyContent={"flex-start"}>
                                                <Typography variant={"h6"}>
                                                    Scorecard
                                                </Typography>
                                            </Grid>
                                            <Grid size={10} container alignItems={"center"} style={{gap: "0.5em"}}>
                                                <Form onSubmit={update} initialValues={dataFilter}
                                                      decorators={[calculator]}
                                                      render={({handleSubmit, pristine, invalid}) => {
                                                          return (
                                                              <form
                                                                  onSubmit={handleSubmit}
                                                                  style={{
                                                                      display: "flex",
                                                                      flex: 1,
                                                                      justifyContent: "flex-end",
                                                                      gap: "0.5em"
                                                                  }}
                                                              >
                                                                  <Field
                                                                      component={FormHelperEnhancedSelectWrapper as any}
                                                                      name='termType'
                                                                      label={"Date Range"}
                                                                      options={[
                                                                          {label: "Past 7 Days", value: "7days"},
                                                                          {label: "Past 30 Days", value: "30days"},
                                                                          {label: "This Month", value: "thisMonth"},
                                                                          {label: "Last Month", value: "lastMonth"},
                                                                          {label: "Custom", value: "custom"}
                                                                      ]}
                                                                      formControlProps={{style: {minWidth: "200px"}}}
                                                                  />
                                                                  <IfEquals field='termType' value='custom'>
                                                                      <Field component={FormHelperEnhancedTextWrapper}
                                                                             type='date'
                                                                             label='Start Date' name='start'/>
                                                                      <Field component={FormHelperEnhancedTextWrapper}
                                                                             type='date'
                                                                             label='End Date' name='end'/>
                                                                  </IfEquals>
                                                                  <div style={{alignSelf: 'flex-end'}}>
                                                                      <Button variant='contained' type='submit'
                                                                              disabled={pristine}
                                                                              color='primary'>
                                                                          Update
                                                                      </Button>
                                                                  </div>
                                                              </form>
                                                          );
                                                      }}
                                                />
                                            </Grid>
                                        </Grid>
                                        {refreshing ? (
                                            <div style={{
                                                height: "250px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}>
                                                <CircularProgress/>
                                            </div>
                                        ) : (
                                            <Grid container>
                                                <Grid size={3} style={{display: "flex", flexDirection: "column", alignItems: "flex-start"}}>
                                                    <Typography variant={"h6"}>
                                                        Overall Score
                                                    </Typography>
                                                    <div style={{margin: scorecardData.NoData ? "1em" : "1.5em"}}>
                                                        <div
                                                            className='partnerLetter letterColor'
                                                            data-grade={!scorecardData.NoData ? scorecardData.Combined?.LetterGrade ?? '' : ''}
                                                        >
                                                            {scorecardData.NoData
                                                                ? <div className='noScoreData'>NO DATA</div>
                                                                : ''
                                                            }
                                                            <sup className='letterSup'></sup>
                                                        </div>
                                                    </div>
                                                    <Grid container style={{width: "100%"}}>
                                                        <Grid size={6} style={{display: "flex", flexDirection: "column", alignItems: "flex-start"}}>
                                                            <Typography color={"textSecondary"}>
                                                                Orders
                                                            </Typography>
                                                            <Typography>
                                                                {scorecardData.NoData ? "N/A" : scorecardData.OrderCount}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid size={6} style={{display: "flex", flexDirection: "column", alignItems: "flex-start"}}>
                                                            <Typography color={"textSecondary"}>
                                                                Sales
                                                            </Typography>
                                                            <Typography>
                                                                {scorecardData.NoData ? "N/A" : scorecardData.OrderTotalAmount}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid size={9} style={{display: "flex", flexDirection: "column", gap: "1em"}}>
                                                        <Grid container>
                                                            <Grid size={6}
                                                                  style={{display: "flex", flexDirection: "column", alignItems: "flex-start"}}>
                                                                <Typography color={"textSecondary"}>
                                                                    Shipment Time
                                                                </Typography>
                                                                <Typography style={{textAlign: "left"}}>
                                                                    {scorecardData.NoData ? "N/A" : (
                                                                        <>
                                                                            Target: {scorecardData.ShipmentTime?.TargetValue ?? 0} hours
                                                                            to fully ship, Average
                                                                            time: {formatHoursWithDays(scorecardData.ShipmentTime?.ActualValue)}
                                                                            {scorecardData.ShipmentTimeWeight &&
                                                                                <Fragment><br/>This makes
                                                                                    up {(scorecardData.ShipmentTimeWeight * 100).toFixed(0)}%
                                                                                    of your total score.</Fragment>}
                                                                        </>
                                                                    )}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={6}
                                                                  style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
                                                                <Typography>
                                                                    {scorecardData.NoData ? "N/A" : scorecardData.ShipmentTime?.LetterGrade ?? ''} ({scorecardData.ShipmentTime?.Score?.toFixed(2) ?? 0})
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container>
                                                            <Grid size={6}
                                                                  style={{display: "flex", flexDirection: "column", alignItems: "flex-start"}}>
                                                                <Typography color={"textSecondary"}>
                                                                    Percent Shipped
                                                                </Typography>
                                                                <Typography style={{textAlign: "left"}}>
                                                                    {scorecardData.NoData ? "N/A" : (
                                                                        <>
                                                                            Target: {scorecardData.ShipPercent?.TargetValue ?? 0}%
                                                                            shipped,
                                                                            Actual: {scorecardData.ShipPercent?.ActualValue ?? 0}%
                                                                            shipped
                                                                            {scorecardData.ShipPercentWeight &&
                                                                                <Fragment><br/>This makes
                                                                                    up {(scorecardData.ShipPercentWeight * 100).toFixed(0)}%
                                                                                    of your total score.</Fragment>}
                                                                        </>
                                                                    )}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={6}
                                                                  style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
                                                                <Typography>
                                                                    {scorecardData.NoData ? "N/A" : scorecardData.ShipPercent?.LetterGrade ?? ''} ({scorecardData.ShipPercent?.Score?.toFixed(2) ?? 0})
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container>
                                                            <Grid size={6}
                                                                  style={{display: "flex", flexDirection: "column", alignItems: "flex-start"}}>
                                                                <Typography color={"textSecondary"}>
                                                                    Percent Cancelled
                                                                </Typography>
                                                                <Typography style={{textAlign: "left"}}>
                                                                    {scorecardData.NoData ? "N/A" : (
                                                                        <>
                                                                            Target: {scorecardData.CancelPercent?.TargetValue ?? 0}%
                                                                            cancelled or less,
                                                                            Actual: {scorecardData.CancelPercent?.ActualValue ?? 0}%
                                                                            cancelled
                                                                            {scorecardData.CancelPercentWeight &&
                                                                                <Fragment><br/>This makes
                                                                                    up {(scorecardData.CancelPercentWeight * 100).toFixed(0)}%
                                                                                    of your total score.</Fragment>}
                                                                        </>
                                                                    )}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid size={6}
                                                                  style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
                                                                <Typography>
                                                                    {scorecardData.NoData ? "N/A" : scorecardData.CancelPercent?.LetterGrade ?? ''} ({scorecardData.CancelPercent?.Score?.toFixed(2) ?? 0})
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Paper>
                                </Grid>
                                <Grid size={12} container style={{height: "fit-content"}}>
                                    <Paper style={{width: "100%", padding: "1em"}}>
                                        {refreshing ? (
                                            <div style={{
                                                height: "250px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}>
                                                <CircularProgress/>
                                            </div>
                                        ) : (
                                            <>
                                                <Typography variant="h6"
                                                            component="h2">{'Order Shipment Status'}</Typography>
                                                {chartData.length > 0 ? (
                                                    <div
                                                        style={{height: (chartData && chartData.length > 25 ? ((chartData.length / 25) * 350) : 350) + 'px'}}>
                                                        <ResponsiveBar
                                                            {...({
                                                                layout: 'horizontal',
                                                                margin: {
                                                                    "top": 30,
                                                                    "right": 130,
                                                                    "bottom": 60,
                                                                    "left": 60
                                                                },
                                                                data: chartData,
                                                                indexBy: "Date",
                                                                keys: ["Shipped", "Not Shipped", "Cancelled"],
                                                                animate: false,
                                                                colorBy: (data: any) => {
                                                                    if (data.id === 'Shipped') {
                                                                        return "#448044";
                                                                    }
                                                                    if (data.id === 'Cancelled') {
                                                                        return "#aaa";
                                                                    }
                                                                    return "#ffa500";
                                                                },
                                                                enableLabel: false,
                                                            } as any)}
                                                        /></div>
                                                ) : (
                                                    <div style={{
                                                        height: "150px",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center"
                                                    }}>
                                                        No data available
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </Paper>
                                </Grid>
                                {refreshing ? (
                                            <Grid size={12}><Paper><div style={{
                                                height: "250px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}>
                                                <CircularProgress/>
                                            </div></Paper></Grid>
                                        ) : <CancellationReasons isRetailer={props.isRetailer} partnerId={urlPartnerId} startDate={Moment(dataFilter.start).toISOString()} endDate={Moment(dataFilter.end).toISOString()}/>}
                                <Grid size={12} container style={{height: "fit-content"}}>
                                    <WarehousesTable
                                        warehouses={partnerProfile.Warehouses}
                                    />
                                </Grid>
                                <Grid size={12} container style={{height: "fit-content"}}>
                                    <ClosuresTable
                                        closures={partnerProfile.Closures}
                                    />
                                </Grid>
                            </Grid>
                            <Grid size={3} container style={{height: "fit-content", gap: "1em"}}>
                                <Grid container>
                                    <Paper style={{width: "100%", padding: "1em"}}>
                                        <Grid container>
                                            <Typography variant={"h6"}>
                                                General
                                            </Typography>
                                        </Grid>
                                        {refreshing ? (
                                            <div style={{
                                                height: "250px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}>
                                                <CircularProgress/>
                                            </div>
                                        ) : (
                                            <Grid container>
                                                <Grid size={6} container direction={"column"} alignItems={"flex-start"}
                                                      style={{padding: "0.25em 0"}}>
                                                    <Typography color={"textSecondary"} style={{textAlign: "left"}}>
                                                        Company Name
                                                    </Typography>
                                                    <Typography style={{textAlign: "left"}}>
                                                        {partnerData.CompanyName}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={6} container direction={"column"} alignItems={"flex-start"}
                                                      style={{padding: "0.25em 0"}}>
                                                    <Typography color={"textSecondary"}>
                                                        Logicbroker Account Number
                                                    </Typography>
                                                    <Typography>
                                                        {partnerData.Id}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={6} container direction={"column"} alignItems={"flex-start"}
                                                      style={{padding: "0.25em 0"}}>
                                                    <Typography color={"textSecondary"}>
                                                        Vendor Number
                                                    </Typography>
                                                    <Typography>
                                                        {!partnerVendorNumber ? "N/A" : partnerVendorNumber}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={6} container direction={"column"} alignItems={"flex-start"}
                                                      style={{padding: "0.25em 0"}}>
                                                    <Typography color={"textSecondary"}>
                                                        Connection Type
                                                    </Typography>
                                                    <Typography>
                                                        {partnerData.Type || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid container direction={"column"} alignItems={"flex-start"}
                                                      style={{padding: "0.25em 0"}}>
                                                    <Typography color={"textSecondary"}>
                                                        Supplier Group(s)
                                                    </Typography>
                                                    <Grid container style={{gap: "0.5em", marginTop: "0.25em", alignItems: "center"}}>
                                                        {partnerGroups.length > 0 && (
                                                            partnerGroups.map((group) => (
                                                                <Chip
                                                                    key={group.id}
                                                                    label={group.name}
                                                                    onDelete={() => handleRemoveFromGroup(group.id)}
                                                                    variant="outlined"
                                                                    size="small"
                                                                />
                                                            ))
                                                        )}
                                                        {availableGroups.length > 0 && (
                                                            <Button
                                                                size="small"
                                                                variant="outlined"
                                                                startIcon={<Add style={{fontSize: "16px"}}/>}
                                                                onClick={() => setAddToGroupDialogOpen(true)}
                                                                style={{height: "24px", fontSize: "0.75rem", textTransform: "none"}}
                                                            >
                                                                Add to Group
                                                            </Button>
                                                        )}
                                                        {partnerGroups.length === 0 && availableGroups.length === 0 && (
                                                            <Typography>No groups available</Typography>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Paper>
                                </Grid>
                                <Grid container>
                                    <Paper style={{width: "100%", padding: "1em"}}>
                                        <Grid container>
                                            <Typography variant={"h6"}>
                                                Contacts
                                            </Typography>
                                        </Grid>
                                        {refreshing ? (
                                            <div style={{
                                                height: "250px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}>
                                                <CircularProgress/>
                                            </div>
                                        ) : (
                                            <Grid container>
                                                <Grid container direction={"column"} alignItems={"flex-start"}
                                                      size={6} style={{padding: "0.25em 0"}}>
                                                    <Typography color={"textSecondary"} align={"left"}>
                                                        Merchandiser name
                                                    </Typography>
                                                    <Typography align={"left"} noWrap style={{width: "inherit"}}>
                                                        {!partnerProfile.MerchandiserContact?.FirstName && !partnerProfile.MerchandiserContact?.LastName
                                                            ? "N/A"
                                                            :
                                                            <>
                                                                {partnerProfile.MerchandiserContact?.FirstName || "N/A"} {partnerProfile.MerchandiserContact?.LastName}
                                                            </>
                                                        }
                                                    </Typography>
                                                </Grid>
                                                <Grid container direction={"column"} alignItems={"flex-start"}
                                                      size={6} style={{padding: "0.25em 0"}}>
                                                    <Typography color={"textSecondary"} align={"left"}>
                                                        Merchandiser email address
                                                    </Typography>
                                                    <Typography align={"left"} noWrap style={{width: "inherit"}}>
                                                        {partnerProfile.MerchandiserContact?.Email || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid container direction={"column"} alignItems={"flex-start"}
                                                      size={6} style={{padding: "0.25em 0"}}>
                                                    <Typography color={"textSecondary"} align={"left"}>
                                                        Partnership name
                                                    </Typography>
                                                    <Typography align={"left"} noWrap style={{width: "inherit"}}>
                                                        {!partnerProfile.PartnershipContact?.FirstName && !partnerProfile.PartnershipContact?.LastName
                                                            ? "N/A"
                                                            :
                                                            <>
                                                                {partnerProfile.PartnershipContact?.FirstName || "N/A"} {partnerProfile.PartnershipContact?.LastName}
                                                            </>
                                                        }
                                                    </Typography>
                                                </Grid>
                                                <Grid container direction={"column"} alignItems={"flex-start"}
                                                      size={6} style={{padding: "0.25em 0"}}>
                                                    <Typography color={"textSecondary"} align={"left"}>
                                                        Partnership email address
                                                    </Typography>
                                                    <Typography align={"left"} noWrap style={{width: "inherit"}}>
                                                        {partnerProfile.PartnershipContact?.Email || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid container direction={"column"} alignItems={"flex-start"}
                                                      size={6} style={{padding: "0.25em 0"}}>
                                                    <Typography color={"textSecondary"} align={"left"}>
                                                        Operations name
                                                    </Typography>
                                                    <Typography align={"left"} noWrap style={{width: "inherit"}}>
                                                        {!partnerProfile.OperationsContact?.FirstName && !partnerProfile.OperationsContact?.LastName
                                                            ? "N/A"
                                                            :
                                                            <>
                                                                {partnerProfile.OperationsContact?.FirstName || "N/A"} {partnerProfile.OperationsContact?.LastName}
                                                            </>
                                                        }
                                                    </Typography>
                                                </Grid>
                                                <Grid container direction={"column"} alignItems={"flex-start"}
                                                      size={6} style={{padding: "0.25em 0"}}>
                                                    <Typography color={"textSecondary"} align={"left"}>
                                                        Operations email address
                                                    </Typography>
                                                    <Typography align={"left"} noWrap style={{width: "inherit"}}>
                                                        {partnerProfile.OperationsContact?.Email || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid container direction={"column"} alignItems={"flex-start"}
                                                      size={6} style={{padding: "0.25em 0"}}>
                                                    <Typography color={"textSecondary"} align={"left"}>
                                                        Customer Service name
                                                    </Typography>
                                                    <Typography align={"left"} noWrap style={{width: "inherit"}}>
                                                        {!partnerProfile.CustomerServiceContact?.FirstName && !partnerProfile.CustomerServiceContact?.LastName
                                                            ? "N/A"
                                                            :
                                                            <>
                                                                {partnerProfile.CustomerServiceContact?.FirstName || "N/A"} {partnerProfile.CustomerServiceContact?.LastName}
                                                            </>
                                                        }
                                                    </Typography>
                                                </Grid>
                                                <Grid container direction={"column"} alignItems={"flex-start"}
                                                      size={6} style={{padding: "0.25em 0"}}>
                                                    <Typography color={"textSecondary"} align={"left"}>
                                                        Customer Service email address
                                                    </Typography>
                                                    <Typography align={"left"} noWrap style={{width: "inherit"}}>
                                                        {partnerProfile.CustomerServiceContact?.Email || "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid container direction={"column"} alignItems={"flex-start"}
                                                      size={6} style={{padding: "0.25em 0"}}>
                                                    <Typography color={"textSecondary"} align={"left"}>
                                                        IT name
                                                    </Typography>
                                                    <Typography align={"left"} noWrap style={{width: "inherit"}}>
                                                        {!partnerProfile.ITContact?.FirstName && !partnerProfile.ITContact?.LastName
                                                            ? "N/A"
                                                            :
                                                            <>
                                                                {partnerProfile.ITContact?.FirstName || "N/A"} {partnerProfile.ITContact?.LastName}
                                                            </>
                                                        }
                                                    </Typography>
                                                </Grid>
                                                <Grid container direction={"column"} alignItems={"flex-start"}
                                                      size={6} style={{padding: "0.25em 0"}}>
                                                    <Typography color={"textSecondary"} align={"left"}>
                                                        IT email address
                                                    </Typography>
                                                    <Typography align={"left"} noWrap style={{width: "inherit"}}>
                                                        {partnerProfile.ITContact?.Email || "N/A"}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Paper>
                                </Grid>
                                <Grid container>
                                    <Paper style={{width: "100%", padding: "1em"}}>
                                        <Grid container>
                                            <Typography variant={"h6"}>
                                                Hours of Operation
                                            </Typography>
                                        </Grid>
                                        {refreshing ? (
                                            <div style={{
                                                height: "250px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}>
                                                <CircularProgress/>
                                            </div>
                                        ) : (
                                            <HoursOfOperation hours={partnerProfile.Hours} />
                                        )}
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Grid>
                    </>
                )}
            </Grid>
            <PartnerUnpauseDialog open={unpauseDialogOpen} setOpen={setUnpauseDialogOpen} partnerIds={[urlPartnerId]}
                onUnpause={() => setPartnerData({...partnerData, Status: "Live"})}
            />
            <PartnerPauseDialog open={pauseDialogOpen} setOpen={setPauseDialogOpen} partnerIds={[urlPartnerId]}
                onPause={() => setPartnerData({...partnerData, Status: "Paused"})}
            />
            <AddToGroupDialog 
                open={addToGroupDialogOpen} 
                setOpen={setAddToGroupDialogOpen}
                availableGroups={availableGroups}
                partnerId={urlPartnerId}
                partnerName={partnerData.CompanyName}
                onSave={() => loadPartnerGroups()}
            />
            <EnhancedErrorDialog
                open={error.open}
                errorHeader={error.errorHeader}
                errorMessage={error.errorMessage}
                onClose={() => setError({...error, open: false})}
            />
        </div>
    );
}
